var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditCreditsAdd.jinja');
require('./MemberProfileEditCreditsAdd.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditCreditsAdd-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditCreditsAdd-buttons-button--save': 'saveEdit',
        'input input': 'onInputChange',
        'blur input[name="url"]': 'onImdbUrlBlur',
        'keyup input[name="url"]': 'onImdbUrlKeyUp',
        'click .MemberProfileEditCreditsAdd-info': 'onInfoClick',
        'click .MemberProfileEditCreditsAdd-body-form-switcher': 'onSwitcherClick',

    },

    imdbApi: function () {
        return (Urls['imdb:api:search']('json'));
    },


    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'saveApi', 'getFormData', 'onInputChange', 'imdbApi', 'getImdbInfo', 'onBodyClick');

        if (!window.app.cache.imdb) {
            window.app.cache.imdb = {};
        }

        this.isAdd = !this.options.item;

        this.$('.MemberProfileEditCreditsAdd-buttons-button--save').text(this.isAdd ? 'save' : 'edit');

        this.cache = window.app.cache.imdb;

        this.onInputChange();


        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.imdbXHR && this.imdbXHR.abort();

        return Base.prototype.deactivate.call(this, params);
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MemberProfileEditCreditsAdd-infoPopup').length) return;

        if ($(e.currentTarget).hasClass('MemberProfileEditCreditsAdd-info--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('MemberProfileEditCreditsAdd-info--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.MemberProfileEditCreditsAdd-info').removeClass('MemberProfileEditCreditsAdd-info--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MemberProfileEditCreditsAdd-info').length) return;

        this.closeAllInfoPopups();
    },


    onSwitcherClick: function(e) {
        var $switcher = $(e.currentTarget);
        var switcherType = $switcher.attr('data-type');

        this.imdbXHR && this.imdbXHR.abort();


        this.$('input[name="title"]')
                .removeAttr('disabled')
                .css('opacity', 1);

        this.$('.MemberProfileEditCreditsAdd-body-form-input-cover img')
            .attr('src', this.$('.MemberProfileEditCreditsAdd-body-form-input-cover').attr('data-empty'))
            .show();

        this.$('.MemberProfileEditCreditsAdd-body').attr('data-state', switcherType);
    },


    onImdbUrlBlur: function (e) {
        this.getImdbInfo();
    },


    onImdbUrlKeyUp: function (e) {
        if (e.keyCode == 13) {
            this.$('input[name="role"]').focus();
        }
    },


    getImdbInfo: function () {
        var $inputUrl = this.$('input[name="url"]');
        var $inputTitle = this.$('input[name="title"]');
        var $loader = this.$('.MemberProfileEditCreditsAdd-loader');
        var $img = this.$('.MemberProfileEditCreditsAdd-body-form-input-cover img');
        var $inputCover = this.$('input[name="cover"]');
        var url = $inputUrl.val();
        var tmp = url.match(/tt\d+/);
        var imdbId;
        var self = this;

        $img.removeAttr('src').hide();
        $inputCover.val('');
        $inputTitle.val('')
            .attr('disabled', '')
            .css('opacity', 0.7);

        if (tmp && tmp.length) {
            imdbId = tmp[0];
        }

        if (!imdbId) return;

        $loader.show();

        this.imdbXHR && this.imdbXHR.abort();

        this.loading = true;
        this.onInputChange();

        if (this.cache[url]) {
            if (this.cache[url].error) {
                onError(this.cache[url]);
            } else {
                onSuccess(this.cache[url]);
            }
        } else {
            this.imdbXHR = $.ajax({
                type: 'GET',
                url: this.imdbApi() + '?id=' + imdbId,
                dataType: 'json',
                success: function (data) {
                    onSuccess(data);
                    self.cache[url] = data;
                },
                error: function (data, tp) {
                    if (tp == 'abort') {
                        $loader.hide();
                        self.loading = false;
                        self.onInputChange();

                        return;
                    }

                    onError(data);
                    self.cache[url] = data;
                    self.cache[url].error = true;
                }
            });
        }


        function onSuccess(data) {
            $img.attr('src', data.cover ? data.cover.w680_url : this.$('.MemberProfileEditCreditsAdd-body-form-input-cover').attr('data-empty')).show();
            $inputCover.val(JSON.stringify(data.cover));
            $inputTitle.val(data.title)
                .closest('.MemberProfileEditCreditsAdd-body-form-inputWrapper')
                .slideDown(200);
            self.$('input[name="url"]')
                .attr('disabled', '')
                .css('opacity', 0.7);
            $loader.hide();
            self.loading = false;
            self.onInputChange();

            this.$('.MemberProfileEditCreditsAdd-body-form-inputWrapper--switchers').slideUp(200);
        }

        function onError(data) {
            $loader.hide();
            $img.attr('src', this.$('.MemberProfileEditCreditsAdd-body-form-input-cover').attr('data-empty')).show();
            self.$('input[name="title"]')
                .removeAttr('disabled')
                .css('opacity', 1)
                .closest('.MemberProfileEditCreditsAdd-body-form-inputWrapper')
                .slideDown(200);
            self.$('input[name="url"]')
                .attr('disabled', '')
                .css('opacity', 0.7);
            self.loading = false;
            self.onInputChange();

            this.$('.MemberProfileEditCreditsAdd-body-form-inputWrapper--switchers').slideUp(200);
        }
    },


    saveEdit: function () {
        var self = this;
        var data = this.getFormData();
        var form = data.data;

        if (this.loading) return;

        var $productionInput = this.$('input[name="url"]');

        if ($productionInput.is(':disabled')) {
            $productionInput = this.$('input[name="title"]');
        }

        $productionInput.toggleClass('error', !this.$('input[name="title"]').val());
        this.$('input[name="role"]').toggleClass('error', !this.$('input[name="role"]').val());

        if (!data.valid) {
            if (!form.role) this.$('input[name="role"]').focus();
            if (!form.title) $productionInput.focus();

            return;
        }

        if (this.isAdd) {
            var $button = this.$('.MemberProfileEditCreditsAdd-buttons-button--save');

            $button.addClass('Button--loading');

            var order = 0;
            form.order = order;
            delete form.id;

            _.each(window.app.data.members[this.options.memberId].credits, function (item) {
                item.order = ++order;
            });

            var switcherState = this.$('.MemberProfileEditCreditsAdd-body').attr('data-state');

            if (switcherState == 'custom') {
                form.url = '';
            }


            var data = [form].concat(window.app.data.members[this.options.memberId].credits);

            this.saveXhr = $.ajax({
                url: this.saveApi(),
                method: 'PATCH',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify({
                    credits: data
                }),
                success: function (responseData) {

                    app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                    $button.removeClass('Button--loading');

                    //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                    //response always contain all profile data up-to-date
                    window.app.data.members[this.options.memberId] = responseData;

                    window.app.vent.trigger('MemberProfile--updateCredits', this.options.memberId);

                    this.cancelEdit();
                },
                error: function (e, tp) {
                    $button.removeClass('Button--loading');

                    if (tp != 'abort') {
                        alert('Can\'t add new credit!');
                    }

                    console.log('error', arguments);
                },
                context: this
            });
        } else {
            window.app.vent.trigger('MemberProfileEdit--editCredit', form);

            this.cancelEdit();
        }
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        this.imdbXHR && this.imdbXHR.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'creditsEdit');
    },


    onInputChange: function () {
        var data = this.getFormData();
        this.$('.MemberProfileEditCreditsAdd-buttons-button--save').toggleClass('active', !!data.valid && !this.loading);

        this.$('input[name="url"]').removeClass('error');
        this.$('input[name="role"]').removeClass('error');

    },

    getFormData: function () {
        var id = this.$('input[name="id"]').val();
        var url = this.$('input[name="url"]').val();
        var role = this.$('input[name="role"]').val();
        var season = this.$('input[name="season"]').val();
        var cover = this.$('input[name="cover"]').val();
        var title = this.$('input[name="title"]').val();

        cover = cover ? JSON.parse(cover) : null;

        return {
            valid: !!title && !!role,
            data: {
                'id': id,
                'url': url,
                'role': role,
                'season': season,
                'cover': cover,
                'title': title
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.js
// module id = 205
// module chunks = 0